export { GoIcon } from "./go";
